import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIConstants } from '../../../../app/_config/restapis';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class APIObserverService {

  constructor(
    private http: HttpClient
  ) {
          
   }
   getGraph(data) {
    return this.http.post(APIConstants.COMGRAPH,data)
  }
  public getEntitycount(): Observable<any> {
    return this.http.get(APIConstants.ENTITYCOUNT)
  }
  public getTeleMarketercount(): Observable<any> {
    return this.http.get(APIConstants.TELEMARKETERCOUNT)
  }
  public getHeadercount(): Observable<any> {
    return this.http.get(APIConstants.HEADERCOUNT)
  }
  public getContentTemplatecount(): Observable<any> {
    return this.http.get(APIConstants.CONTENTTEMPLATECOUNT)
  }
  public getComplaintcount(): Observable<any> {
    return this.http.get(APIConstants.COMPLAINTCOUNT)
  }
  public getConsentcount(): Observable<any> {
    return this.http.get(APIConstants.CONSENTCOUNT)
  }
  public getPreferencecount(): Observable<any> {
    return this.http.get(APIConstants.PREFCOUNT)
  }

  public getEntityDataForObserver(data): Observable<any> {
    return this.http.post(APIConstants.GETENTITYDATAFOROBSERVER,data)
  }
  public searchEntityDataForObserver(data): Observable<any> {
    return this.http.post(APIConstants.SEARCHENTITYDATAFOROBSERVER,data)
  }
  public downloadEntityDataForObserver(data): Observable<any> {
    return this.http.post(APIConstants.DOWNLOADENTITYDATAFOROBSERVER,data, { responseType: "blob" })
  }

  public getTMDataForObserver(data): Observable<any> {
    return this.http.post(APIConstants.GETTMDATAFOROBSERVER,data)
  }
  public searchTMDataForObserver(data): Observable<any> {
    return this.http.post(APIConstants.SEARCHTMDATAFOROBSERVER,data)
  }
  public downloadTMDataForObserver(data): Observable<any> {
    return this.http.post(APIConstants.DOWNLOADTMDATAFOROBSERVER,data, { responseType: "blob" })
  }
  public ObserverHeader(data): Observable<any> {
    return this.http.post(APIConstants.GETHEADERDATAFOROBSERVER,data)
  }
  public filterObserverData(data): Observable<any> {
    return this.http.post(APIConstants.SEARCHHEADERFOROBSERVER,data)
  }
  public ObserverHeaderDownload(data): Observable<any> {
    return this.http.post(APIConstants.DOWNLOADHEADERDATAFOROBSERVER,data, { responseType: "blob" })
  }
  public getCSTDataForObserver(data): Observable<any> {
    return this.http.post(APIConstants.GETCSTDATAFOROBSERVER,data)
  }
  public searchCSTDataForObserver(data): Observable<any> {
    return this.http.post(APIConstants.SEARCHCSTDATAFOROBSERVER,data)
  }
  public downloadCSTDataForObserver(data): Observable<any> {
    return this.http.post(APIConstants.DOWNLOADCSTDATAFOROBSERVER,data, { responseType: "blob" })
  }
  
  public getCTDataForObserver(data): Observable<any> {
    return this.http.post(APIConstants.GETCTDATAFOROBSERVER,data)
  }
  public searchCTDataForObserver(data): Observable<any> {
    return this.http.post(APIConstants.SEARCHCTDATAFOROBSERVER,data)
  }
  public downloadCTDataForObserver(data): Observable<any> {
    return this.http.post(APIConstants.DOWNLOADCTDATAFOROBSERVER,data, { responseType: "blob" })
  }

  public filterComplaintsObserverData(data): Observable<any> {
    return this.http.post(APIConstants.SEARCHCOMPLAINTSFOROBSERVER,data)
  }
  
  public ObserverComplaintsDownload(data): Observable<any> {
    return this.http.post(APIConstants.DOWNLOADCOMPLAINTSDATAFOROBSERVER,data, { responseType: "blob" })
  }
  
  public fetchConsent(data): Observable<any> {
    console.log("data fetch consent ",data);
    return this.http.post(APIConstants.FETCHCONSENT,data)
  }
  public getPreferencesForObserver(data): Observable<any> {
    return this.http.get(APIConstants.GETPREFERENCESFOROBSERVER +'/'+data)
  }
  public ObserverPreferenceCount(operator): Observable<any> {
    var data = {
      "TSP":operator
    }
    return this.http.post(APIConstants.OBSERVERPREFERENCECOUNT,data)
  }

  public filterComplaintsObvComprehensiveData(data): Observable<any> {
    return this.http.post(APIConstants.COMPLAINTSOBVCOMPREHENSIVERPT,data)
  }

  public downloadComplaintsComprehensiveReportFile(data): Observable<any> {
    return this.http.post(APIConstants.DOWNLOADCOMPLAINTSOBVCOMPREHENSIVERPT,data,{ responseType: "blob" })
  }
  
  public complaintsObserverDataCount(data): Observable<any> {
    return this.http.post(APIConstants.COMPLAINTSFOROBSERVERCOUNT,data)
  }
}

